import React, { Component } from "react";
import { connect } from "react-redux";
import LayoutWrap from "./Component/LayoutWrap";
import { FiMail, FiCheckSquare, FiCalendar, FiArrowRight } from "react-icons/fi";

class AdminHome extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  goToPage = (path) => {
    this.props.history.push(path);
  };

  render() {
    const { replyingMails = 12, pendingTasks = 8, pendingMeetings = 5 } = this.props; // mock / from API

    return (
      <LayoutWrap>
        <div className="min-h-screen bg-gray-100 p-6">

          {/* HEADER */}
          <div className="mb-8">
            <h1 className="text-2xl font-bold text-gray-800">
              Admin Dashboard
            </h1>
            <p className="text-sm text-gray-500">
              Monitor employee activity and pending actions
            </p>
          </div>

          {/* DASHBOARD CARDS */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

            {/* 1️⃣ Replying Mails */}
            <div className="bg-white rounded-2xl shadow p-6 flex flex-col justify-between border-l-4 border-blue-500">
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <FiMail className="text-blue-500 text-xl" />
                  <h2 className="text-lg font-semibold text-gray-700">
                    Replying Mails
                  </h2>
                </div>

                <p className="text-3xl font-bold text-gray-800">
                  {replyingMails}
                </p>
                <p className="text-xs text-gray-500 mt-1">
                  Employees actively replying
                </p>
              </div>

              <button
                onClick={() => this.goToPage("/insight/mails")}
                className="mt-6 flex items-center text-blue-600 text-sm font-medium hover:underline"
              >
                View Details <FiArrowRight className="ml-1" />
              </button>
            </div>

            {/* 2️⃣ Pending Tasks */}
            <div className="bg-white rounded-2xl shadow p-6 flex flex-col justify-between border-l-4 border-yellow-500">
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <FiCheckSquare className="text-yellow-500 text-xl" />
                  <h2 className="text-lg font-semibold text-gray-700">
                    Pending Tasks
                  </h2>
                </div>

                <p className="text-3xl font-bold text-gray-800">
                  {pendingTasks}
                </p>
                <p className="text-xs text-gray-500 mt-1">
                  Tasks not completed yet
                </p>
              </div>

              <button
                onClick={() => this.goToPage("/insight/tasks")}
                className="mt-6 flex items-center text-yellow-600 text-sm font-medium hover:underline"
              >
                View Tasks <FiArrowRight className="ml-1" />
              </button>
            </div>

            {/* 3️⃣ Pending Meetings */}
            <div className="bg-white rounded-2xl shadow p-6 flex flex-col justify-between border-l-4 border-green-500">
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <FiCalendar className="text-green-500 text-xl" />
                  <h2 className="text-lg font-semibold text-gray-700">
                    Pending Meetings
                  </h2>
                </div>

                <p className="text-3xl font-bold text-gray-800">
                  {pendingMeetings}
                </p>
                <p className="text-xs text-gray-500 mt-1">
                  Meetings yet to connect
                </p>
              </div>

              <button
                onClick={() => this.goToPage("/insight/meetings")}
                className="mt-6 flex items-center text-green-600 text-sm font-medium hover:underline"
              >
                View Meetings <FiArrowRight className="ml-1" />
              </button>
            </div>

          </div>

          {/* FOOTER */}
          <footer className="mt-12 text-xs text-gray-500 text-center">
            © 2026 ABG Development. All rights reserved.
          </footer>
        </div>
      </LayoutWrap>
    );
  }
}

const mapStateToProps = (state) => ({
  replyingMails: state.dashboard?.replyingMails,
  pendingTasks: state.dashboard?.pendingTasks,
  pendingMeetings: state.dashboard?.pendingMeetings,
});

export default connect(mapStateToProps)(AdminHome);